// extracted by mini-css-extract-plugin
module.exports = {"orderSuccessBox":"OrderSuccess_orderSuccessBox__2LbSy","successMessage":"OrderSuccess_successMessage__hYMr-"};